export const validateTeamForm = (
  teamName: string,
  description: string,
  teamHOD: string | number | null,
  emailAddress: string,
  phoneNumber: string, // Add phoneNumber as a parameter
  faxNumber: string
): string[] => {
  const errors: string[] = []; // Array to hold error messages

  const trimmedTeamName = teamName.trim();
  const trimmedDescription = description.trim();
  const trimmedEmailAddress = emailAddress.trim();
  const trimmedPhoneNumber = phoneNumber.trim();
  const trimmedfaxNumber = faxNumber.trim();

  if (!trimmedTeamName) {
    errors.push("Team Name is mandatory");
  }

  if (trimmedPhoneNumber) {
    const phoneRegex = /^\d{3}-\d{3}-\d{4}$/;
    if (!phoneRegex.test(trimmedPhoneNumber)) {
      errors.push("Team Phone is invalid.");
    }
  }
  if (trimmedfaxNumber) {
    const faxRegex = /^\d{3}-\d{3}-\d{4}$/;
    if (!faxRegex.test(trimmedfaxNumber)) {
      errors.push("Fax number is invalid.");
    }
  }

  if (trimmedEmailAddress) {
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(trimmedEmailAddress)) {
      errors.push(
        "Invalid email format. Ensure it contains one '@' symbol, valid characters, and a proper domain."
      );
    }
  }
  // if (!trimmedDescription) {
  //   errors.push("Description is mandatory");
  // }
  if (teamHOD === null || teamHOD === "") {
    errors.push("Please select Team Leader");
  }

  // Email validation

  return errors; // Return the array of errors
};
